export default "__VITE_ASSET__DKnK8sJG__"